<template>
  <v-menu>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :color="color"
        elevation="0"
        max-width="80px"
        class="font-weight-black"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon :color="iconColor">language</v-icon>
        {{ $store.state.config.lang }}
        <v-icon :color="iconColor">arrow_drop_down</v-icon>
      </v-btn>
    </template>

    <v-list dense class="my-n2">
      <v-list-item @click="$root.changeLang('es')">
        <v-list-item-title>ES</v-list-item-title>
      </v-list-item>
      <v-list-item @click="$root.changeLang('en')">
        <v-list-item-title>EN</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  props: {
    dark: Boolean,
    color: {
      type: String,
      default: "white",
    },
  },
  computed: {
    iconColor: (vm) => (vm.dark ? "white" : "primary"),
  },
};
</script>
